
// @ts-nocheck





import { i18nText } from '@/locales';


import { servicePrice, lineAmount } from "@/UI/pages/visitsNew/Lib/money";
import { lxDateToSpecFormat, parseDateFormatted, addPrefix } from "@/UI/lib/parseSupport";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { Col, DatePicker, FormModel, Input, Row, Select, Table, Tabs } from "ant-design-vue";

import { DateTime, Duration, Interval } from "ts-luxon";
import dayjs from "dayjs";
import { SimpleProxyForm } from "@/UI/components/Helpers/SimpleProxyForm";
import { AppStateStore } from "@/store/modules/appState";

import { getStudioId } from "@/UI/lib/state";
import { VisitsGeneralMix } from "@/UI/mixins/Visits/VisitsGeneralMix";
import { VisitSupportMix } from "@/UI/pages/visitsNew/mixins/Support";
import { StatusMix } from "@/UI/pages/visitsNew/mixins/StatusMix";
import { ServiceStore } from "@/store/modules/Services";

import { loyaltySubscriptionForm } from "@/form/loyalty/loyaltySubscription/loyaltySubscription";

import { ClientsStore } from "@/store/modules/Clients";
import { LoyaltySubscriptionTypeStore } from "@/store/modules/Loyalty/Subscription/LoyaltySubscriptionType";
import { ProductsStockStore } from "@/store/modules/Warehouse/ProductsStock";
import { CashboxStore } from "@/store/modules/Finance/Cashbox";
import RecordStatus from "@/UI/pages/visitsNew/Components/RecordStatus.vue";
import { VisitsStore } from "@/store/modules/Visits";
import { showNotificationSimple } from "@/UI/lib/messages";
import { AppFormsStore } from "@/store/modules/appForms";
import { RecordDataForm } from "@/form/visits/New/Record";
import { RouterNameEnum } from "@/router/router.types";
import {
  getVisitData,
  newVisitS,
  RecordParams,
  RecordParamsData,
  RecordParamsEvent,
  parseVisitsData,
  updateVisitData,
} from "@/UI/pages/visitsNew/Lib/support";
import { HandleScrollStorewithParam, HandleScrollStore, SearchinStore } from "@/UI/Decorators/decorator";

@Component({
  components: {
    BaseDataForm,
    RecordStatus,
    "a-input": Input,
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-col": Col,
    "a-row": Row,
    "a-date-picker": DatePicker,
    "a-textarea": Input.TextArea,
    "a-form-model": FormModel,
    "a-form-model-item": FormModel.Item,
    "a-tabs": Tabs,
    "a-tab-pane": Tabs.TabPane,
    "a-table": Table,
  },
  methods: { dayjs },
})
export default class StatusRecord extends mixins(
  SimpleProxyForm,
  VisitsGeneralMix,
  VisitSupportMix,
  StatusMix,
) {
  form = new RecordDataForm();
  disabled_table_data: boolean = false
  open_modal_prod_serv: boolean = false
  prod_serv_modal_title: string = ''
  prod_serv_data: any = []
  sData: any = {}
  tree_data_keys: any = []

  prepareServicesData() {
    if (this.services && this.services.data) {
      this.dataService = [];
      const groups: Record<string, any> = {};
      //const categories: Record<string, any> = {};

      this.services.data.forEach((item: any) => {
        if (groups[item.category.name]) {
          groups[item.category.name].push(item);
        } else {
          groups[item.category.name] = [item];
        }
        this.dataService.push(item);
      });

      for (const [key, elements] of Object.entries(groups)) {
        this.treeServices.push({
          title: key,
          key: key,
          children: elements.map((element: any) => ({
            title: element.name,
            key: element.id,
          })),
        });
      }
    }
  }

  prepareProductsData() {
    if (this.products && this.products.data) {
      this.dataProducts = [];
      let existItems: Array<number> = [];
      let existCategories: Array<number> = [];
      this.products.data.forEach((item: any) => {
        if (!existItems.includes(item.product_nomenclature_id)) {
          this.productsList.push({
            title: item.nomenclature.name,
            key: item.id,
          });
          existItems.push(item.product_nomenclature_id);

          if (!existCategories.includes(item.nomenclature.category_id)) {
            let array: Array<any> = [];
            if (this.products && this.products.data) {
              let existKids: Array<number> = [];
              for (let i = 0; i < this.products.data.length; i++) {
                if (
                  !existKids.includes(this.products.data[i].nomenclature.id) &&
                  item.nomenclature.category.id == this.products.data[i].nomenclature.category_id
                ) {
                  array.push({
                    title: this.products.data[i].nomenclature.name,
                    key: this.products.data[i].id,
                  });
                  existKids.push(this.products.data[i].nomenclature.id);
                }
              }
            }

            this.treeProducts.push({
              title: item.nomenclature.category.name,
              key: "category_" + item.nomenclature.category.id,
              children: array,
            });

            existCategories.push(item.nomenclature.category_id);
          }
        }
      });
    }
  }

  @HandleScrollStorewithParam
  hScrollServices(event: any, source: string, items: string): void {
    this.prepareServicesData()
  }
  @HandleScrollStorewithParam
  hScrollProducts(event: any, source: string, items: string): void {
    this.prepareProductsData()
  }

  handleScrollServices(event: any, source: string, items: string): void {
    this.hScrollServices(event, "services", "service");
    console.log('services', this.services)
  }

  handleScrollProducts(event: any, source: string, items: string): void {
    this.hScrollProducts(event, "productsStock", "items");
    console.log('products', this.products)
  }

  onSelect(selectKeys: any): void {
    console.log(selectKeys)
  }

  onCheck(checkedKeys: any): void {
    if (this.prod_serv_modal_title === 'Услуги') {
      this.tree_data_keys = checkedKeys
    }
    if (this.prod_serv_modal_title === 'Товары') {
      this.tree_data_keys = checkedKeys
    }
  }

  addProductCert(): void {
    if (this.prod_serv_modal_title === 'Услуги') {
      for (let i of this.tree_data_keys) {
        this.addTableSelectService(i)
      }
    }
    if (this.prod_serv_modal_title === 'Товары') {
      for (let i of this.tree_data_keys) {
        this.addTableSelectProducts(i)
      }
    }
    this.prod_serv_data = []
    this.open_modal_prod_serv = false
  }

  async selectList(mode: number): Promise<void> {
    if (mode === 1) {
      this.prod_serv_modal_title = i18nText("Услуги")
      this.prod_serv_data = this.treeServices
    }
    if (mode === 2) {
      this.prod_serv_modal_title = i18nText("Товары")
      this.prod_serv_data = this.treeProducts
    }
    this.open_modal_prod_serv = true
  }

  async LinkAddCertificate(): Promise<void> {
    await Vue.router.push({ name: this.$routeRules.VisitsNewStatusAddCertificate });
  }

  deleteData(id: number): void {
    const index = this.boxData.findIndex((t: any) => t.key === id);
    //this.boxData.splice(index, 1);
    AppFormsStore.deleteData(index);
  }

  deleteDataInTable(record: any): void {
    const index = this.boxData.findIndex((item: any) => item.name === record.name);
    //this.boxData.splice(index, 1);
    AppFormsStore.deleteData(index);
  }

  get cash_cashboxes(): any {
    if (this.cashBoxes && this.cashBoxes.data) {
      return this.cashBoxes.data.filter((e) => e && e.type && e.type.id == 1);
    } else {
      return [];
    }
  }

  get card_cashboxes(): any {
    if (this.cashBoxes && this.cashBoxes.data) {
      return this.cashBoxes.data.filter((e) => e && e.type && e.type.id == 2);
    } else {
      return [];
    }
  }

  async proceedPay(id: number): Promise<void> {
    this.visibleCashCashboxes = false;
    this.visibleCardCashboxes = false;

    this.visitPayForm.visit_id = this.visit.id
    this.visitPayForm.cashbox_id = id;
    this.visitPayForm.sum = Number(this.total.replace(' ', ''))
    // this.visitPayForm.sum = this.form.order.sum - this.form.order.paid
    let response = await VisitsStore.pay(this.visitPayForm);
    if (response && response.status) {
      this.$message.success(response.response);
      Vue.router.push({
        name: RouterNameEnum.VisitsNewPayReport,
        params: {
          form: JSON.stringify({ form: this.visitPayForm, response: response }),
        },
      });
    } else {
      this.$message.error(response.response);
    }
  }

  async StatusChange(): Promise<void> {
    // await this.saveVisit(false);
  }

  async saveVisit(noRoute?: boolean): Promise<void> {
    AppStateStore.setSubmit(false);
    // if (this.form.id === 0) this.form.id = 129

    await updateVisitData(
      true,
      this.form,
      RecordParamsData(),
      noRoute as any,
      VisitsStore,
      AppStateStore,
      newVisitS(),
      getStudioId(this),
      // route,
      // route_name
    );
    showNotificationSimple(i18nText("визит успешно обнолен"), "", 2);
  }

  @Watch("$store.state.appState.sendDelete", { immediate: false })
  async ButtonDelete(): Promise<void> {
    if (AppStateStore.sendDelete) {
      AppStateStore.setDelete(false);
      await this.deleteVisit(this.form);
    }
  }

  @Watch("$store.state.appState.sendSubmit", { immediate: false })
  async ButtonSubmit(value: boolean): Promise<void> {
    if (AppStateStore.sendSubmit) {
      await this.saveVisit(true);
    }
  }

  @Watch("$store.state.appState.sendCancel", { immediate: false })
  async ButtonCancel(value: boolean): Promise<void> {
    if (AppStateStore.sendCancel) {
      AppStateStore.setCancel(false);
      //await this.pushToCalendar(this.form, RecordParamsData());
      await this.pushToCalendar(this.form, RecordParams());

    }
  }

  async fetchClients(value: string): Promise<void> {
    await ClientsStore.fetchAll({ filter: { name: value, salon_id: getStudioId(this) } });
    if (ClientsStore.clients?.data) {
      let items = ClientsStore.clients.data;
      this.dataClients = [];
      items.forEach((item) => {
        this.dataClients.push(item);
      });
    }
  }

  async fetchSubscriptionsTypes(val?: string): Promise<void> {
    let data: Record<any, any> = { filter: { salon_id: getStudioId(this) } };

    if (val) {
      data.filter.name = val;
    }
    await LoyaltySubscriptionTypeStore.fetchAll(data);
    if (this.subscriptionsTypes && this.subscriptionsTypes.data) {
      this.dataSubscriptionTypes = [];
      this.subscriptionsTypes.data.forEach((item: any) => {
        this.dataSubscriptionTypes.push(item);
      });
    }
  }

  async fetchProducts(): Promise<void> {
    await ProductsStockStore.fetchAll({ filter: { salon_id: getStudioId(this) } });
    this.prepareProductsData()
  }



  async fetchService(): Promise<void> {
    await ServiceStore.fetchAll({ filter: { salon_id: getStudioId(this) } });
    this.prepareServicesData()
  }

  async addSubscriptionInBox(): Promise<void> {
    if (this.dataSubscriptionTypes) {
      const membershipId = String(this.formSubsscription.membership_type_id);
      let item = this.dataSubscriptionTypes.find(
        (record: any) => record.id === Number(membershipId.replace("type-", "")),
        //(record: any) => record.id === this.formSubsscription.membership_type_id,
      );
      if (item) {
        let data: Record<any, any> = {
          type: "membership",
          name: item.name,
          data: {
            membership_type_id: this.formSubsscription.membership_type_id,
            discount: this.formSubsscription.discount,
          },
          created: 1,
          balance: item.price,
          discount: this.formSubsscription.discount,
          total: item.price,
        };
        if (this.formSubsscription.discount) {
          data.total = item.price * Number(this.formSubsscription.discount) / 100
        } else {
          data.discount = 0
        }

        if (item.children && item.children.length) {
          data.children = item.children;
        }

        if (data) {
          AppFormsStore.addData(data);
        }

        this.visitPayForm.membership_id = this.formSubsscription.membership_type_id
        //await this.pushToBox(data);
        this.formSubsscription = new loyaltySubscriptionForm();
        this.modalWindowsSubscription = false;
      }
    }
  }

  async addTableSelectService(serviceId: any, data?: Record<any, any>): Promise<void> {
    await ServiceStore.fetchData({ filter: { id: serviceId } });
    if (this.serviceData && !AppFormsStore.boxData.find((serv) => serv.type === "service" && serv.key === serviceId)) {
      const price = data && data.price != null ? Number(data.price) :
        servicePrice(this.serviceData, this.visit.staff?.cosmetolog_category_id);
      const quantity = data && data.quantity != null ? Number(data.quantity) : 1;
      const discount = data && data.discount != null ? Number(data.discount) : 0;
      await AppFormsStore.addData({
        type: "service",
        key: this.serviceData.id,
        id: this.serviceData.id,
        name: this.serviceData.name,
        balance: price,
        created: quantity,
        discount,
        total: lineAmount({ price, quantity, discount }),
      });
    }
  }

  async addTableSelectProducts(productId: any, data?: Record<any, any>): Promise<void> {
    if (this.products && this.products.data) {
      let product = this.products.data.find((item: any) => productId == item.id);
      if (product && !AppFormsStore.boxData.find((product) => product.key === productId)) {

        AppFormsStore.addData({
          type: "product",
          key: product.id,
          id: product.id,
          name: product.nomenclature.name,
          created: data && data.quantity ? data.quantity : 1,
          balance: data && data.price ? data.price : parseInt(product.nomenclature.cost_price),
          discount: data && data.discount ? data.discount : 0,
          total: parseInt(product.nomenclature.cost_price),
        });


        if (this.form.products !== null) this.form.products.push(product.id);
        // if (this.form.products === null) {
        //     this.form.products = [];
        //     this.form.products.push(product.id);
        // }
      }
    }
  }

  async setBasket(): Promise<void> {
    if (this.form && this.form.basket) {
      //this.form.client_id = this.visit.client.id;

      for (const service of this.form.basket.services) {
        await this.addTableSelectService(service["service_id"], service);
      }

      this.form.basket.products?.map(async (product: any) => {
        await this.addTableSelectProducts(product["product_id"], product);
      });

      this.form.basket.memberships?.map(async (membership: any) => {
        let data: Record<any, any> = {
          type: "membership",
          key: membership["membership_id"],
          id: membership["membership_id"],

          name: i18nText("Абонемент №") + membership["membership"]["membership_number"],
          created: membership["quantity"],
          balance: membership["price"],
          discount: membership["discount"],
          total: 0,
        };
        //await this.pushToBox(data);
        AppFormsStore.addData(data);
      });

      this.form.basket.certificates?.map(async (certificate: any) => {
        let data: Record<any, any> = {
          type: "certificate",
          key: certificate["certificate_id"],
          id: certificate["certificate_id"],
          name: i18nText("Сертификат №") + certificate["certificate"]["code"],
          created: certificate["quantity"],
          balance: certificate["price"],
          discount: certificate["discount"],
          total: 0,
        };
        //await this.pushToBox(data);
        AppFormsStore.addData(data);
      });
    }
  }

  async prepareBasket(): Promise<void> {
    this.form.service_data = [];

    for (let i = 0; i < AppFormsStore.boxData.length; i++) {
      let data: any = {
        quantity: AppFormsStore.boxData[i].created,
        price: AppFormsStore.boxData[i].balance,
        discount: AppFormsStore.boxData[i].discount,
      };

      if (AppFormsStore.boxData[i].type == "service") {
        data["service_id"] = AppFormsStore.boxData[i].key;
      } else if (AppFormsStore.boxData[i].type == "product") {
        data["product_id"] = AppFormsStore.boxData[i].key;
      } else if (AppFormsStore.boxData[i].type == "certificate") {
        if (AppFormsStore.boxData[i].key) {
          data["certificate_id"] = AppFormsStore.boxData[i].key;
        }

        if (AppFormsStore.boxData[i].data) {
          data["data"] = AppFormsStore.boxData[i].data;
          data["type"] = "certificate";
          data["need_create"] = true;
        }
      } else if (AppFormsStore.boxData[i].type == "membership") {
        if (AppFormsStore.boxData[i].key) {
          data["membership_id"] = this.boxData[i].key;
        }

        if (AppFormsStore.boxData[i].data) {
          data["data"] = AppFormsStore.boxData[i].data;
          data["type"] = "membership";
          data["need_create"] = true;
        }
      } else {
        data = {};
      }
      if (data) {
        this.form.service_data.push(data);
      }
    }

  }

  async startPay(): Promise<void> {
    await this.prepareBasket();

    // ----- counting total chosen services duration (Starting line.) -----

    let userChosenServicesIds = [];
    for (let i = 0; i < this.form.service_data.length; i++) {
      const element = this.form.service_data[i];
      // eslint-disable-next-line no-prototype-builtins
      if (element.hasOwnProperty('service_id')) {
        userChosenServicesIds.push(element.service_id);
      }
    }
    let userChosenServices = this.services.data.filter((element) => {
      return userChosenServicesIds.includes(element.id);
    });

    let allServicesDurationInMinutes = 0;

    userChosenServices.forEach((element) => {
      let serviceDurationHHMMSSArr = element.service_duration.split(":");
      allServicesDurationInMinutes += +serviceDurationHHMMSSArr[0] * 60 + +serviceDurationHHMMSSArr[1];
    });

    let formTimeStartHHMMSSArr = this.form.visit_date_time_start.split(":");
    let formTimeStartInMinutes = +formTimeStartHHMMSSArr[0] * 60 + +formTimeStartHHMMSSArr[1];

    let formTimeEndInMinutes = formTimeStartInMinutes + allServicesDurationInMinutes;
    let formTimeEndInHHMMSSStr = (parseInt(formTimeEndInMinutes / 60).toString().length > 1 ? parseInt(formTimeEndInMinutes / 60) : ("0" + parseInt(formTimeEndInMinutes / 60))) + ":" + ((formTimeEndInMinutes % 60).toString().length > 1 ? formTimeEndInMinutes % 60 : ("0" + formTimeEndInMinutes % 60));
    this.form.visit_date_time_end = formTimeEndInHHMMSSStr; // based on that working this.form.visit_date_time_end = "18:34"
    this.form.visit_duration = (parseInt(allServicesDurationInMinutes / 60).toString().length > 1 ? parseInt(allServicesDurationInMinutes / 60) : ("0" + parseInt(allServicesDurationInMinutes / 60))) + ":" + ((allServicesDurationInMinutes % 60).toString().length > 1 ? allServicesDurationInMinutes % 60 : ("0" + allServicesDurationInMinutes % 60));

    await this.form.setVisitDt(this.form.visit_date_time_start, formTimeEndInHHMMSSStr);
    // this.form.visit_duration = durationTp;

    // ----- counting total chosen services duration (Ending line.) -----

    const response = await VisitsStore.update(this.form);
    if (response["status"]) {
      showNotificationSimple(
        i18nText(" Успешное обновление данных визита, переход к оплате "),
        response.response,
        10,
      );

      await Vue.router.push({
        name: this.$routeRules.VisitsNewPay,
        params: { id: this.$router.currentRoute.params["id"] },
      });
    } else {
      showNotificationSimple(i18nText(" Ошибка обновления  визита -"), response.response, 2);

    }

    return;
    // Двойное обновление. Следует доработать.
    if (!this.form.checkDuration(this.form, this.$store.state["visits"]["workersInVisits"], this.$router.currentRoute.params["id"], {
      start: this.form.exportFormatedDates().startDt as any,
      end: this.form.exportFormatedDates().endDt as any,
    }).result) {
      AppStateStore.setSubmit(false);

      await updateVisitData(
        true,
        this.form,
        RecordParamsData(),
        true,
        VisitsStore,
        AppStateStore,
        newVisitS(),
        getStudioId(this),
        // route,
        // route_name
      );

      let vDate = "";
      if (newVisitS()) {
        vDate =
          addPrefix(String(RecordParamsData()["day"])) +
          "." +
          addPrefix(String(RecordParamsData()["month"])) +
          "." +
          addPrefix(String(RecordParamsData()["year"]));
      } else {
        if (RecordParamsData().visitData !== undefined) {
          vDate =
            addPrefix(
              String(parseDateFormatted(RecordParamsData().visitData["visit_dt"].replace(" ", ",")).day),
            ) +
            "." +
            addPrefix(
              String(
                parseDateFormatted(RecordParamsData().visitData["visit_dt"].replace(" ", ",")).month,
              ),
            ) +
            "." +
            addPrefix(
              String(parseDateFormatted(RecordParamsData().visitData["visit_dt"].replace(" ", ",")).year),
            );
        } else {
          vDate =
            addPrefix(String(parseDateFormatted(RecordParamsData()["visit_dt"].replace(" ", ",")).day)) +
            "." +
            addPrefix(String(parseDateFormatted(RecordParamsData()["visit_dt"].replace(" ", ",")).month)) +
            "." +
            addPrefix(String(parseDateFormatted(RecordParamsData()["visit_dt"].replace(" ", ",")).year));
        }
      }

      await parseVisitsData(vDate, vDate, VisitsStore, getStudioId(this));
      await VisitsStore.VisitsByWorker(Number(this.form.cosmetologists_id));
    } else {
      AppStateStore.setSubmit(false);
      showNotificationSimple(i18nText("время визита уже занято"), "", 10);
    }
    // ----- если мы сохраняем в "Статус визита" добавленную услугу то на вкладке "Детали записи" у нее длительность 0, также как и на календаре записей,  fix (Starting line.) -----
  }

  async getData(): Promise<void> {
    // try {
    this.formReady = false;
    await VisitsStore.clearData();
    const recordP = RecordParams();


    if (Number(recordP.isNew) === 1) {
      let visitId = recordP.id;

      const event = RecordParamsEvent();
      if (event !== undefined) {
        event.id = Number(recordP.id);

        // Зачем это?
        // Вернуть, если появятся баги
        /*await this.form.parseVisitData(event);
        await updateVisitData(
            true,
            event,
            RecordParamsData(),
            true,
            VisitsStore,
            AppStateStore,
            newVisitS(),
            getStudioId(this),
        );*/

        await getVisitData(Number(event.id), VisitsStore);
        await this.form.parseVisitData(this.visit);

      } else {
        await getVisitData(Number(visitId), VisitsStore);
        await this.form.parseVisitData(this.visit);
      }
    } else {

      const event = RecordParamsEvent();

      if (event) {
        await this.form.parseVisitData(event);
        if (!event.form) {
          await getVisitData(Number(this.$router.currentRoute.params["id"]), VisitsStore);
          await this.form.parseVisitData(this.visit);
          /*await updateVisitData(
              true,
              event.form,
              RecordParamsData(),
              true,
              VisitsStore,
              AppStateStore,
              newVisitS(),
              getStudioId(this),
          );*/
        }
      } else {
        // @ts-ignore
        // await getVisitData(Number(Vue.router.currentRoute.params["id"], VisitsStore));

        await VisitsStore.fetchData({ filter: { id: Vue.router.currentRoute.params["id"] } });
        await this.form.parseVisitData(this.visit);
      }
    }
    await AppFormsStore.clearData();
    await ServiceStore.fetchAll({ filter: { salon_id: getStudioId(this) } });

    await this.fetchClients("");
    //await this.fetchCertificatesTypes();
    await this.fetchSubscriptionsTypes();
    await this.fetchService();
    await this.fetchProducts();

    await CashboxStore.fetchAll({ filter: { salon_id: getStudioId(this) } });
    await this.setBasket();
    // } catch (e) {
    //     console.log("Ошибка формы статуса визита " + e);
    // } finally {
    //await this.calculator({});
    this.tableLoad = true;
    this.formReady = true;
    // }
  }

  async mounted(): Promise<void> {

    // try {
    await this.getData();
    if (Number(this.visit.status_id) === 5 || this.visit.order.paid === this.visit.order.sum) this.disabled_table_data = true
    // } catch (e) {
    //     console.log("Ошибка создания формы визита -:" + e);
    // }
  }

  async showServices(): Promise<void> {
    AppFormsStore.clearData();
    AppFormsStore.setNotReady();
    await Vue.router.push({
      name: RouterNameEnum.VisitsNewService,
    });
  }
}
